import { API_URL, } from '../../actions/settings';
import NotificationPopUp from "./NotificationPopUp";
import { UnexpectedError } from "../../pages/Errors/Errors";

async function getSoftwareURL(token:any,data:any) {

  return fetch(`${API_URL}/s3/download/software`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization':token
    },
    body: JSON.stringify(data),

  })
    .then((res) => {
      if (res.status === 200) {
        return res.json();
      } else {
        console.log(res)
        throw new UnexpectedError();
      }
    })
    .catch((error) => {
      NotificationPopUp(
        "error",
        "Could not Download Software",
        "Download Error",
        1200
      );
      return null;
    });
 }


async function AE2SoftwareDownload(path:string,filename:string) {

    const path_params = path.split('/')

      const data = {
	      "path":path_params[0] || '',
	      "filename":path_params.slice(1).join('/') +'/'+filename
      }

    try{
        // const res = await bucket.getSignedUrlPromise(GetObjectCommand,params)
        const token = `Token ${(localStorage.getItem("token")||'').slice(1, -1)}`;
        const url = await getSoftwareURL(token,data)
        window.location.assign(url['presigned_url'])
    }catch (error){
        console.log(error)
    }

}

export default AE2SoftwareDownload